module.exports = __webpack_public_path__ + "static/media/RecommendedTest2.bdbf43c1.svg";